import { Tooltip } from 'antd';
import CustomSelect from '../../../../components/select/CustomSelect';
import { SvgArrowDownSelect } from '../../../../components/@svg/SvgArrowDownSelect';
import { TEbayTax, ebayTaxKey } from '../../../../util/ebay-tax';

type TProps = {
  options: TEbayTax[];
  value?: TEbayTax | null;
  disabled?: boolean;
  onChange: (tax: TEbayTax) => void;
};

/**
 * Chọn 1 trong nhiều thuế eBay thu hộ. Danh sách hiện "<tên> <số>", ô đã chọn chỉ hiện số (tên nằm ở nhãn).
 * Ô hẹp nên số dài bị cắt -> rê chuột vào ô / từng dòng để xem đầy đủ.
 */
const EbayTaxSelect = ({ options, value, disabled, onChange }: TProps) => (
  <Tooltip title={value?.value || undefined}>
    <CustomSelect
      className="ioss-select"
      suffixIcon={<SvgArrowDownSelect />}
      options={options.map((tax) => ({ value: ebayTaxKey(tax), label: ebayTaxKey(tax), title: ebayTaxKey(tax) }))}
      value={value?.value ? ebayTaxKey(value) : undefined}
      labelRender={({ value: key }) => options.find((tax) => ebayTaxKey(tax) === key)?.value ?? key}
      popupMatchSelectWidth={false}
      disabled={disabled}
      placeholder="選択してください"
      onChange={(key: string) => {
        const tax = options.find((option) => ebayTaxKey(option) === key);
        if (tax) onChange(tax);
      }}
    />
  </Tooltip>
);

export default EbayTaxSelect;
